var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forms",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.9a1abfa1.svg";
export { ForwardRef as ReactComponent };